<template>
    <div class="cart">
        <a :href="'/' + culture + '/shop/review'" onclick="return false;" rel="nofollow" v-on:click="toggleCartSlider(true, Cart.NumberOfCartItems)" class="cart-summary-container2 fadeIn track-GA4-event" data-ga4_name="navigation_click" data-ga4_title="n/a" data-ga4_title1="n/a" data-ga4_click_text="cart" id="cart-summary-container2" :class="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0 ? 'cart-summary-empty' : ''">
            <span aria-hidden="true"><i class="glyphicon glyphicon-shopping-cart"></i></span>
            <span class="sr-only">{{ Cart.NumberOfCartItems }} item(s) in cart</span>
            <span id="summary-NumberOfItems" class="NumberOfItems" v-show="Cart.NumberOfCartItems != undefined && Cart.NumberOfCartItems > 0">{{ Cart.NumberOfCartItems }}</span>
            <span class="NumberOfItems ZeroItems" v-show="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0">0</span>
            <span id="summary-total" class="hidden-xs">{{ Cart.TotalToFormat }}</span>
            <span class="sr-only">{{getInterfaceText('cart_total_amount')}} {{ Cart.TotalToFormat }}</span>
        </a>

        <!-- cart slider -->
        <div id="cart-summary-slider" :style="displaySlider" :class="isCartSummaryOpen && Cart.CartItems && Cart.CartItems.length > 0 ? 'slide-out' : 'slide-in'" aria-label="Cart" role="dialog" aria-modal="true" v-if="isOpen" @keydown="handleKeydown" ref="modal">
            <div id="overlay" style="width: 100%; height: 100%; position: inherit; top: 0; left: 0; background: rgba(0, 0, 0, 0.3); z-index: 99;" v-show="CartInProgress == true">
                <div class="lds-dual-ring" style="min-height:100%"></div>
            </div>
            <div id="title-and-close-button" class="clearfix">
                <div class="title">
                    <h4>{{getInterfaceText('shoppingcart')}}</h4>
                </div>
                <div class="close-button text-right">
                    <button v-on:click="toggleCartSlider(false)" id="cartCloseButton" aria-label="close" class="btn-close">&times;</button>
                </div>
            </div>
            <div id="body">
                <div v-show="Cart.LockedCart == false">
                    <CartTable :edit-mode="true" :summary-mode="true"></CartTable>
                </div>
                <div v-show="Cart.LockedCart == true" v-html="Cart.LockedCartDescription"></div>
            </div>

            <div id="relatedproducts" v-if="Cart.RelatedProducts && Cart.RelatedProducts.length > 0">
                <RelatedProducts></RelatedProducts>
            </div>

            <div id="totals">
                <CartTotals :edit-mode="true" :summary-mode="true"></CartTotals>
            </div>

            <div id="actions" v-show="!Cart.LockedCart">
                <div class="text-center">
                    <button id="proceedToCheckoutButton" v-on:click="redirectToCart" class="btn btn-proceed btn-enable-progress" style="width:100%;">{{getInterfaceText('shop_proceedtocheckout')}}</button>
                    <p>
                        <a href="javascript:void(0);" v-on:click="toggleCartSlider(false)" class="continue">{{getInterfaceText('shop_continueshopping')}}</a>
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTable from '@/components/CartTable.vue';
    import CartTotals from '@/components/CartTotals.vue';
    import RelatedProducts from '@/components/RelatedProducts.vue';
    export default {
        name: 'CartSummary',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTable,
            CartTotals,
            RelatedProducts
        },
        data: function () {
            return {
                isCartSummaryOpen: false,
                loading: true,
                culture: window.culture,
                isInTestMode: window.window.inTestMode,
                displaySlider: 'display:none;',
                isOpen: {
                    type: Boolean,
                    default: false
                }
            }
        },
        beforeMount() {
            // get summary
            this.getCartSummary(false);
        },
        methods: {
            redirectToCart: function () {
                window.location = '/' + this.culture + '/shop/review';
            },
            toggleCartSlider(showSlider, nrOfItems) {
                var hasItems = nrOfItems > 0;
                var that = this;
                if (showSlider && hasItems) {
                    this.displaySlider = 'display:block';
                    setTimeout(function () {
                        // then slide
                        that.isCartSummaryOpen = true;
                    }, 100);
                    // no scrolling in the body
                    document.body.style.overflow = 'hidden';
                    // a360
                    setTimeout(function () {
                        document.getElementById('cartCloseButton').focus();
                    }, 100);
                    // ga4
                    this.handleGA4data();
                } else {
                    this.isCartSummaryOpen = false;
                    setTimeout(function () {
                        // then slide
                        that.displaySlider = 'display:none';
                    }, 100);
                    // scrolling is back
                    document.body.style.overflow = 'unset';
                }

                // visible vs hidden for a360
                setTimeout(function () {
                    console.log("wait and check position");
                    const myCart = document.getElementById('cart-summary-slider');
                    var cartContainsOpenClass = myCart.classList.contains('slide-out');
                    console.log("cartContainsOpenClass : " + cartContainsOpenClass);
                    if (cartContainsOpenClass) {
                        myCart.style.visibility = '';
                    } else {
                        myCart.style.visibility = 'hidden';
                    }
                }, 100);
            },
            handleGA4data: function () {

                //GA4
                var items = [];
                for (var i = 0; i < this.Cart.CartItems.length; i++) {
                    items.push({
                        'item_id': (this.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + this.Cart.CartItems[i].Product.Id.toString(),
                        'item_name': this.Cart.CartItems[i].Product.Name.toLowerCase(),
                        'discount': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal > 0 ? this.Cart.CartItems[i].Product.Partnumber.PriceOriginal - this.Cart.CartItems[i].Product.Partnumber._price : 0,
                        'index': 1,
                        'item_brand': this.Cart.CartItems[i].Product.BrandName.toLowerCase(),
                        'item_category': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 0 ? this.Cart.CartItems[i].Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 1 ? this.Cart.CartItems[i].Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 2 ? this.Cart.CartItems[i].Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                        /*'item_list_name': this.Cart.CartItems[i].Product.GA_Category,*/
                        'item_variant': (this.Cart.CartItems[i].Product.Partnumber.Size + (this.Cart.CartItems[i].Product.Partnumber.Color != undefined && this.Cart.CartItems[i].Product.Partnumber.Color.length > 0 ? ' ' + this.Cart.CartItems[i].Product.Partnumber.Color : '')).toLowerCase(),
                        'price': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal,
                        'quantity': this.Cart.CartItems[i].Quantity
                    });
                }
                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_cart',
                    'ga4_currency': window.currencyCode,
                    'ga4_value': this.Cart.TotalIncludingShippingCosts,
                    'ga4_items': items
                });

                //Related products
                let result = [];
                for (let item of this.Cart.RelatedProducts) {
                    let newItem = {
                        item_id: 'gearproduct-' + item.Id,
                        item_name: item.Name,
                        index: item.Index,
                        item_brand: item.Brand,
                        item_category: item.Category,
                        item_category2: item.Category2,
                        item_category3: item.Category3,
                        price: item.Price,
                        discount: item.Discount,
                        quantity: 1
                    }
                    result.push(newItem);
                }

                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_item_list',
                    'ga4_item_list_name': 'complete your rider experience',
                    'ga4_location': 'mini cart',
                    'ga4_items': result
                });
            },
            handleKeydown(event) {
                const focusableElements = this.getFocusableElements();
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstElement) {
                            event.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastElement) {
                            event.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            },
            getFocusableElements() {
                return this.$refs.modal.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
            }
        },
        computed: {
            // See cartMixin
        },
        watch: {
            isOpen(newVal) {
                if (newVal) {
                    // Wacht tot de DOM volledig is gerenderd voordat je probeert $refs te gebruiken
                    this.$nextTick(() => {
                        const focusableElements = this.getFocusableElements();
                        if (focusableElements.length) {
                            focusableElements[0].focus(); // Focus op het eerste element bij openen
                        }
                    });
                }
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
